export default "__VITE_ASSET__BiQ9_OYJ__"